import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  customerData: {},
  hasReadOnlyAccess: false,
  source: "",
  permissions: {
    agent: {
      members: { view: true, update: true },
      "members-dob": { view: true, update: true },
      quote: { view: true, update: true },
      proposal: { view: true, update: true },
      nstp: { view: false, update: false },
      "order-tracking": { view: true, update: true },
      "submit-documents": { view: true, update: true },
      "counter-offer": { view: true, update: true },
      "order-summary": { view: true, update: true },
      pdp: { view: true, update: true },
      "pdp-benefits": { view: true, update: true },
      port: { view: true, update: true },
      "tagic-telemer": { view: false, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: true, update: true },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: true, update: true },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: true, update: true },
      "personal-accident/members": { view: true, update: true },
      "personal-accident/members-dob": { view: true, update: true },
      "personal-accident/pdp": { view: true, update: true },
      "personal-accident/pdp-benefits": { view: true, update: true },
      "personal-accident/proposal": { view: true, update: true },
      "personal-accident/kyc-frame": { view: true, update: true },
      "personal-accident/nstp": { view: false, update: false },
      "personal-accident/endorsement/actions": { view: true, update: true },
      "personal-accident/policy-history": { view: true, update: true },
    },
    retention: {
      members: { view: true, update: true },
      "members-dob": { view: true, update: true },
      quote: { view: true, update: true },
      proposal: { view: true, update: true },
      nstp: { view: false, update: false },
      "order-tracking": { view: true, update: true },
      "submit-documents": { view: true, update: true },
      "counter-offer": { view: true, update: true },
      "order-summary": { view: true, update: true },
      pdp: { view: true, update: true },
      "pdp-benefits": { view: true, update: true },
      port: { view: true, update: true },
      "tagic-telemer": { view: false, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: true, update: true },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: false, update: false },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: true, update: true },
      "personal-accident/members": { view: true, update: true },
      "personal-accident/members-dob": { view: true, update: true },
      "personal-accident/pdp": { view: true, update: true },
      "personal-accident/pdp-benefits": { view: true, update: true },
      "personal-accident/proposal": { view: true, update: true },
      "personal-accident/kyc-frame": { view: true, update: true },
      "personal-accident/nstp": { view: false, update: false },
    },
    customer: {
      members: { view: false, update: false },
      "members-dob": { view: false, update: false },
      quote: { view: false, update: false },
      proposal: { view: true, update: false },
      nstp: { view: false, update: false },
      "order-tracking": { view: false, update: false },
      "submit-documents": { view: true, update: true },
      "counter-offer": { view: true, update: true },
      "order-summary": { view: true, update: true },
      "pdp-benefits": { view: true, update: true },
      port: { view: true, update: true },
      "tagic-telemer": { view: false, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: true, update: true },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: true, update: true },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: true, update: true },
      "personal-accident/members": { view: true, update: false },
      "personal-accident/members-dob": { view: true, update: false },
      "personal-accident/pdp": { view: true, update: false },
      "personal-accident/pdp-benefits": { view: true, update: false },
      "personal-accident/proposal": { view: true, update: false },
      "personal-accident/kyc-frame": { view: true, update: true },
      "personal-accident/nstp": { view: false, update: false },
      "personal-accident/endorsement/actions": { view: true, update: true },
      "personal-accident/policy-history": { view: true, update: true },
    },
    cops: {
      members: { view: true, update: true },
      "members-dob": { view: true, update: true },
      quote: { view: true, update: true },
      proposal: { view: true, update: true },
      nstp: { view: true, update: true },
      "order-tracking": { view: true, update: true },
      "submit-documents": { view: false, update: false },
      "counter-offer": { view: false, update: false },
      "order-summary": { view: true, update: true },
      pdp: { view: true, update: true },
      "pdp-benefits": { view: true, update: true },
      port: { view: true, update: true },
      "tagic-telemer": { view: true, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: true, update: true },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: false, update: false },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: true, update: true },
      "kyc-frame": { view: true, update: true },
      "personal-accident/members": { view: true, update: true },
      "personal-accident/members-dob": { view: true, update: true },
      "personal-accident/pdp": { view: true, update: true },
      "personal-accident/pdp-benefits": { view: true, update: false },
      "personal-accident/proposal": { view: true, update: true },
      "personal-accident/kyc-frame": { view: true, update: true },
      "personal-accident/nstp": { view: true, update: true },
      "personal-accident/endorsement/actions": { view: false, update: false },
      "personal-accident/policy-history": { view: true, update: true },
    },
    uw: {
      members: { view: false, update: false },
      "members-dob": { view: false, update: false },
      quote: { view: false, update: false },
      proposal: { view: true, update: true },
      nstp: { view: true, update: true },
      "order-tracking": { view: false, update: false },
      "submit-documents": { view: false, update: false },
      "counter-offer": { view: false, update: false },
      "order-summary": { view: false, update: false },
      "pdp-benefits": { view: false, update: false },
      port: { view: false, update: false },
      "tagic-telemer": { view: true, update: false },
      review: { view: false, update: false },
      "compare-plans": { view: false, update: false },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: false, update: false },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: false, update: false },
      "personal-accident/members": { view: false, update: false },
      "personal-accident/members-dob": { view: false, update: false },
      "personal-accident/pdp": { view: false, update: false },
      "personal-accident/pdp-benefits": { view: false, update: false },
      "personal-accident/proposal": { view: false, update: false },
      "personal-accident/kyc-frame": { view: false, update: false },
      "personal-accident/nstp": { view: true, update: true },
      "personal-accident/endorsement/actions": { view: false, update: false },
      "personal-accident/policy-history": { view: false, update: false },
    },
    teleuw: {
      members: { view: false, update: false },
      "members-dob": { view: false, update: false },
      quote: { view: false, update: false },
      proposal: { view: false, update: false },
      nstp: { view: true, update: false },
      "order-tracking": { view: false, update: false },
      "submit-documents": { view: false, update: false },
      "counter-offer": { view: false, update: false },
      "order-summary": { view: false, update: false },
      "pdp-benefits": { view: false, update: false },
      port: { view: false, update: false },
      "tagic-telemer": { view: true, update: true },
      review: { view: false, update: false },
      "compare-plans": { view: false, update: false },
      "policy-history": { view: false, update: false },
      "endorsement/actions": { view: false, update: false },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: false, update: false },
      "personal-accident/nstp": { view: false, update: false },
    },
    ops: {
      members: { view: false, update: false },
      "members-dob": { view: false, update: false },
      quote: { view: false, update: false },
      proposal: { view: true, update: true },
      nstp: { view: true, update: false },
      "order-tracking": { view: false, update: false },
      "submit-documents": { view: false, update: false },
      "counter-offer": { view: false, update: false },
      "order-summary": { view: true, update: true },
      "pdp-benefits": { view: false, update: false },
      port: { view: false, update: false },
      "tagic-telemer": { view: false, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: false, update: false },
      "endorsement/actions": { view: true, update: true },
      "endorsement/order-tracking": { view: false, update: false },
      "policy-history": { view: true, update: true },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: false, update: false },
      "personal-accident/endorsement/actions": { view: true, update: true },
      "personal-accident/members": { view: true, update: true },
      "personal-accident/members-dob": { view: true, update: true },
      "personal-accident/pdp": { view: true, update: true },
      "personal-accident/pdp-benefits": { view: true, update: true },
      "personal-accident/proposal": { view: true, update: true },
      "personal-accident/kyc-frame": { view: true, update: true },
      "personal-accident/policy-history": { view: true, update: true },
    },
    super: {
      members: { view: true, update: true },
      "members-dob": { view: true, update: true },
      quote: { view: true, update: true },
      proposal: { view: true, update: true },
      nstp: { view: false, update: false },
      "order-tracking": { view: true, update: true },
      "submit-documents": { view: true, update: true },
      "counter-offer": { view: true, update: true },
      "order-summary": { view: true, update: true },
      pdp: { view: true, update: true },
      "pdp-benefits": { view: true, update: true },
      port: { view: true, update: true },
      "tagic-telemer": { view: false, update: false },
      review: { view: true, update: true },
      "compare-plans": { view: true, update: true },
      "policy-history": { view: true, update: true },
      "endorsement/actions": { view: false, update: false },
      "endorsement/order-tracking": { view: false, update: false },
      "cancel-rebook": { view: false, update: false },
      "kyc-frame": { view: true, update: true },
    },
  },
};

export const metadataSlice = createSlice({
  name: "metadata",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCustomerData: (state, action) => {
      state.customerData = {
        ...state.customerData,
        ...action.payload,
      };
    },
    setReadOnlyAccess: (state, action) => {
      state.hasReadOnlyAccess = action.payload;
    },
    clearCustomerData: () => {
      return initialState;
    },
    setSource: (state, action) => {
      state.source = action.payload;
    },
  },
});

export const {
  setCustomerData,
  clearCustomerData,
  setReadOnlyAccess,
  setSource,
} = metadataSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getMetadata = (state) => state?.metadata?.customerData;
export const getPermissions = (state) => state.metadata?.permissions;
export const getIsReadOnly = (state) => state.metadata?.hasReadOnlyAccess;
export const getSource = (state) => state.metadata?.source;

export default metadataSlice.reducer;
